import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { DispatcherLiveVideo } from '@rsos/live-video';
import { removeVideoSession } from '@rsos/reduxDataStore';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import {
  LIVE_VIDEO_CARD,
  closeCard,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import { useCurrentOrgName } from '@rsos/sinatra/src/selectors';
import { notifyInfo } from '@rsos/utils/toastUtils';

export const LiveVideoCard = () => {
  const selectedCallerID = useSelectedCallerID();
  const orgName = useCurrentOrgName();
  const dispatch = useDispatch();
  const handleCardClosing = useCallback(
    () => dispatch(closeCard(LIVE_VIDEO_CARD)),
    [dispatch],
  );
  const handleCallEnding = useCallback(() => {
    handleCardClosing();
    if (selectedCallerID) {
      dispatch(removeVideoSession({ callID: selectedCallerID }));
    }
    notifyInfo('Live video stream ended');
  }, [dispatch, handleCardClosing, selectedCallerID]);

  if (!selectedCallerID || !orgName) {
    return <></>;
  }

  return (
    <DispatcherLiveVideo
      callID={selectedCallerID}
      orgName={orgName}
      handleCardClosing={handleCardClosing}
      handleCallEnding={handleCallEnding}
    />
  );
};
